import { useNextTranslation } from "../../hooks";
import { ProductBookNowButton, ProductBookNowButtonProps } from "../../product/ProductBookNowButton";
import type { ExternalWidgetTravelotopos as ExternalWidgetTravelotoposType } from "../../types/ExternalWidget";

export type ExternalWidgetTravelotoposProps = Omit<ExternalWidgetTravelotoposType, "__typename"> & {
    ButtonComponent?: (props: ProductBookNowButtonProps) => JSX.Element;
};

export function ExternalWidgetTravelotopos({ widgetId, subdomain, ButtonComponent }: ExternalWidgetTravelotoposProps) {
    const [t] = useNextTranslation("externalWidget");
    const Button = ButtonComponent ?? ProductBookNowButton;

    return (
        <Button
            className="travelotoposBtn"
            data-landing={subdomain}
            data-whitelabel={widgetId}
            data-button-text={t("travelotopos.availabilityButton.dataText")}
            disabled={!subdomain}
        >
            {t("travelotopos.availabilityButton.label")}
        </Button>
    );
}
